// The server's own sentence for a refused action, else the fallback.

export function serverMessage(err: unknown, fallback: string): string {
  const e = err as { data?: { error?: { message?: string } }; message?: string } | null;
  return e?.data?.error?.message || e?.message || fallback;
}
